module.exports = __webpack_public_path__ + "static/media/SWSCRC6-45.11f65c08.mp3";